export default __webpack_public_path__ + "static/media/DefaultBlogCover.09eda0cc.jpeg";